<template>
  <div>
    <div class="right-title">
      <span>候选人表单详情</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <div class="search-box">
        <el-input
          class="search"
          type="text"
          prepend="iconbianji1"
          placeholder="请输入ID/候选人姓名"
          v-model="search"
          style="border-radius: 4px !important;margin-right: 10px;">
        </el-input>
        <el-button class="btn2" @click="keyWord" type="primary">搜索</el-button>
      </div>
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',
    color: '#000;'}"
          @selection-change="handleSelectionChange">
          <el-table-column
            fixed
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="user_id"
            label="ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="user_real_name"
            label="姓名"
            align="center"
          >
            <template slot-scope="scope">
              <span class="hals-color" @click="toDetail(scope.row.user_id)">{{scope.row.user_real_name}}</span>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--                  prop=""-->
          <!--                  label="最后一份工作单位"-->
          <!--                  align="center"-->
          <!--          >-->
          <!--            <template slot-scope="scope">-->
          <!--              <span>{{scope.row.work}}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="addr"
            label="候选人详情"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="hal-cursor" @click="toDetail(scope.row.user_id)">候选人详情</span>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="tag_name"-->
          <!--            label="查看标签"-->
          <!--            align="center"-->
          <!--            show-overflow-tooltip>-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="addr"
            label="日志"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span @click="showRizhi(scope.row.user_id)" class="hal-cursor">查看日志</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="lsgw"
            label="隶属顾问"
            align="center"
            show-overflow-tooltip
          >
            <!--            <template slot-scope="scope">-->
            <!--              <span>{{scope.row.lsgw}}</span>-->
            <!--            </template>-->
          </el-table-column>
          <el-table-column
            prop="status"
            label="不信任"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="swBox" style="position: relative;">
                <el-switch
                  v-model="scope.row.status"
                  active-color="#bababa"
                  inactive-color="#f20000"
                >
                </el-switch>
                <div class="swShade" @click="xinR(scope.row.user_id)"
                     style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_lock"
            label="锁定"
            align="center"
            show-overflow-tooltip
            v-if='user.admin_type === 1 || user.admin_type === 2'>
            <template slot-scope="scope">
              <div class="swBox" style="position: relative;">
                <el-switch
                  v-model="scope.row.user_lock"
                  active-color="#bababa"
                  inactive-color="#f20000"
                >
                </el-switch>
                <div class="swShade" @click="suoD(scope.row.user_id)"
                     style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"></div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="addr"
            label="重置密码"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="hal-cursor" @click="chongZhi(scope.row.user_id)">重置密码</span>
            </template>
          </el-table-column>

        </el-table>
        <div class="page-box">
          共计{{page.pageTotal}}条
          <el-button type="danger" @click="deleteList()">删除</el-button>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "hxrBiaoDanDetail",
    data() {
      return {
        search: '',
        tableData: [],     // 数据
        id: "",               //表单id
        multipleSelection: [], //  选中的候选人
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        }
      }
    },
    computed: {
      list() {
        let _list = JSON.parse(JSON.stringify(this.tableData))
        _list.map(item => {
          //隶属顾问
          item.lsgw = ''
          //标签
          item.tag_name = ''
          // 锁定
          item.user_lock = item.user_lock === 0 ? (true) : (false)
          // 信任
          item.status = item.status === 0 ? (true) : (false)
          item.suoshu.map(items => {
            item.lsgw += items.name + ','
          })
          // item.tag_arr.map(items => {
          //   item.tag_name += items.tag_name + ','
          // })
          // item.lsgw = item.lsgw.substring(0, item.lsgw.length - 1)
          // item.tag_name = item.tag_name.substring(0, item.tag_name.length - 1)

        })
        return _list
      },
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 1)
      //表单id
      this.id = this.$route.params.id
      this.biaoDanList()
    },
    methods: {

      //候选人详情
      toDetail(id) {
        this.$router.push({
          path: '/home/hxrAdmin/hxrDetail/' + id
        })
      },
      toggleSelection(rows) {     //  全选或取消全选
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      //表单详情列表
      biaoDanList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        this.$api.apiContent.hjFormD({
          search: this.search,
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
          admin_id: this.user.id,
          id: this.id,
          type: 1
        }).then(res => {
          loading.close();
          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          this.tableData = res.data
        }).catch(() => {
          loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      handleSelectionChange(val) {//  列表选中存入数据
        this.multipleSelection = val;
      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },
      keyWord() {     //  搜索

        if(this.page.pageNum === 1){
          this.setPath()
        }else{
          this.page.pageNum = 1
        }
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/hxrAdmin/hxrBiaoDanDetail/'+ this.id,
          query: {
            pageNum: this.page.pageNum,
            key: this.search,
          }
        })
      },
      deleteList() {   //  删除选中的
        if (this.multipleSelection.length > 0) {
          let len = this.multipleSelection.length
          this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let _arr = []
            this.multipleSelection.map(item => {
              _arr.push(item.user_id)
            })
            this.$api.apiContent.formItemDel({
              id: _arr.join(","),
              type:1,
              form_id:this.$route.params.id,
              admin_id: this.user.id
            }).then(res => {
              if (this.page.pageNum > 1 && len === this.list.length) {
                this.page.pageNum = this.page.pageNum - 1
              } else {
                this.biaoDanList()
              }
              this.$message.success(res.info)
              this.$refs.multipleTable.clearSelection();
            }).catch(res => {
              this.$message.error(res.info)
            })
          }).catch(() => {
            this.$message.info('已取消删除');
          });
        } else {
          this.$message.error("请选中要删除的数据！");
        }
      },
      //  查看日志
      showRizhi(id) {
        this.$router.push({
          path: '/home/hxrAdmin/hxrRizhi',
          query: {
            id: id
          }
        })
      },
      chongZhi(id) { //  重置密码
        this.$confirm("此操作将重置密码，是否继续操作？", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.hxrAndjgSet({
            user_id: id,
            admin_id: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.biaoDanList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //信任不信任
      xinR(id) {
        let state = ""
        this.tableData.map(item => {
          if (item.user_id === id) {
            state = item.status
          }
        })
        let messg = ""
        if (!state) {
          messg = "此操作将不信任用户, 是否继续?"
        } else {
          messg = "此操作将信任用户, 是否继续?"
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.hxrAndjgTrust({
            user_id: id,
            admin_id: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.biaoDanList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //锁定
      suoD(id) {
        let state = ""
        this.tableData.map(item => {
          if (item.user_id === id) {
            state = item.user_lock
          }
        })
        let messg = ""
        if (!state) {
          messg = "此操作将锁定用户, 是否继续?"
        } else {
          messg = "此操作将解锁用户, 是否继续?"
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.hxrAndjgLock({
            user_id: id,
            admin_id: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.biaoDanList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      goBack() {     //  返回上一页
        this.$tools.goBack()
      },
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.biaoDanList()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;

    .search {
      width: 220px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

</style>